import { gsap } from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

window.addEventListener('frame-ready', init)

function init() {

    const CONTAINER = document.querySelector('.good-milk')

    if(!CONTAINER) return

    const Flairs = CONTAINER.querySelectorAll('.good-milk--flair img')

    const Timeline = gsap.timeline({
        scrollTrigger: {
            trigger: CONTAINER,
            start: 'top 90%',
        }
    })

    Timeline.to(Flairs, {
        translateX: 0,
        translateY: 0,
        opacity: 1,
        stagger: {
            each: 0.05,
            ease: "power2.inOut"
        }
    }, "<")

    const h2 = CONTAINER.querySelector('h2 span')
    const p = CONTAINER.querySelector('p')
    const button = CONTAINER.querySelector('a')
    const splash = CONTAINER.querySelectorAll('.splash-wrapper')

    const contentTimeline  = gsap.timeline({
        ease: 'power2.inOut',
        duration: .2,
        opacity: 1,
        scrollTrigger: {
            trigger: h2,
            start: 'top 90%',
        }
    })

    contentTimeline
        .to(h2, { opacity: 1, translateY: 0 })
        .to(p, { opacity: 1, translateY: 0 }, "-=.1")
        .to(button, { opacity: 1, translateY: 0 }, "-=.1")
        .to(splash, { opacity: 1, scale: 1 }, "-=.2")

}
